<template>
  <div>
    <el-date-picker
    style="width:100%;"
      class="dataPicker"
      :ref="type+'Picker'"
      v-model="value"
      :default-time="defaultTime"
      :type="type"
      :disabled="disabled"
      :readonly="disabled"
      :value-format="format"
      :placeholder="placeholder"
      :range-separator="rangeSeparator"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      :picker-options="pickerOptions"
      @focus="focus || focusDefault"
      @change="changeValue"
      :onClick="onClickValue" >
    </el-date-picker>
  </div>
</template>

<script>
  export default {
    name: 'cDataPicker',

    props: {
      type:{
        type:String,// date 日期 daterange 日期范围 datetime 日期和时间 datetimerange 日期和时间范围 
      },
      defaultValue: [String, Number,Array],//默认值
      disabled: [Boolean,Number],//禁用
      modelName: [String,Number],//字段名称
      defaultIndex:{//默认索引值
        type: [String,Number,Array],
        default:''
      },
      pickerOptions:{
        type:Object,
      },
      // format:{
      //   type:String,
      // },
      placeholder:{
        type:String,
        default:'选择日期',
      },
      rangeSeparator:{
        type:String,
        default:'至',
      },
      startPlaceholder:{
        type:String,
        default:'开始日期',
      },
      endPlaceholder:{
        type:String,
        default:'结束日期',
      },
      focus:{
        type:Function,
      },
      defaultTime:{
        type:Array,
      }
    },

    data () {
      return {
        value: undefined,
        inputInner: null,
        format:'yyyy-MM-dd HH:mm'
      }
    },

    components: {
      
    },

    created() {
      
    },

    mounted() {
      this.inputInner = document.getElementsByClassName('el-input__inner')
      for(let i = 0; i<this.inputInner.length; i++){
        let item = this.inputInner[i]
        if(item.placeholder=='选择日期' && item.value.length=='19')item.value=item.value.slice(0,-3)
        item.disabled = false
      }
    },

    updated() {
      this.inputInner = document.getElementsByClassName('el-input__inner')
      for(let i = 0; i<this.inputInner.length; i++){
        let item = this.inputInner[i]
        if(item.placeholder=='选择日期' && item.value.length=='19')item.value=item.value.slice(0,-3)
        item.disabled = false
      }
    },

    methods: {
      changeValue(value){ // daterange 日期范围 datetimerange 日期和时间范围 返回一个数组
        this.$emit('changeValue', {index:this.defaultIndex,value,modelName:this.modelName})
      },
      onClickValue(params){
      },
      focusDefault(){

      }
    },

    computed: {
      
    },

    watch: {
      defaultValue:{
        handler(val,oldVal){
          if(val != undefined){
           this.value =  this.defaultValue
          }
        },
        deep:true,
        immediate:true
      }
    },

  }
</script>

<style>
.dataPicker >>> .el-time-panel{
  right: 0 !important;
}
.dataPicker >>> .el-date-range-picker__editors-wrap{
  width: 100%;
  display: inline-block;
}
.dataPicker >>> .el-popper{
  width: 100%;
}
.dataPicker >>> .el-icon-arrow-right{
  display: none;
}
</style>
